import { render, staticRenderFns } from "./PaymentAndSuppliers.vue?vue&type=template&id=7b972afb&"
import script from "./PaymentAndSuppliers.vue?vue&type=script&lang=js&"
export * from "./PaymentAndSuppliers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports